import { Component, Input, OnInit } from '@angular/core';
import { NgClass } from '@angular/common';
import { Role } from '@app/_models';
import { AccountService } from '@app/_services';
import { environment } from '@environments/environment';

@Component({
    selector: 'app-portal-cards',
    templateUrl: './portal-cards.component.html',
    styleUrls: ['./portal-cards.component.css'],
    standalone: true,
    imports: [NgClass]
})
export class PortalCardsComponent implements OnInit {

  @Input() isMyApplication: boolean;
  account = this.accountService.accountValue;
  roleEnums = Role;
  appBaseUrl = environment.appBaseUrl;
  private isAdmin = false;

  constructor(private accountService: AccountService) { }

  ngOnInit(): void {
      this.isAdmin = this.account.roles.includes(Role.Admin);
  }

  isInRole(roleId: number) {
    return this.account.roles.includes(roleId);
  }

  // adds 100 to the app access role Id to check if the user has the available role in order to hide/show as an available app to purchase
  isInAppAvailableRole(roleId: number) {
    const availableRoleId = 1000 + roleId;
    return this.account.roles.includes(availableRoleId);
  }

  isCardVisible(role: Role) {
    const isMyApp = this.isInRole(role) && this.isMyApplication;
    const isAvailableApp = !this.isInRole(role) && !this.isMyApplication && this.isInAppAvailableRole(role);
    if (isMyApp || isAvailableApp || this.isAdmin) {
      return true;
    }
    return false;
  }

  isAppAccessible(role: Role) {
    const isMyApp = this.isInRole(role) && this.isMyApplication;
    if (isMyApp || this.isAdmin) {
      return true;
    }
    return false;
  }

  logEvent(details: string, additionalDetails: string): void {
    this.accountService.logUTrackEvent(details, additionalDetails);
  }

}
